import { env } from "../env/config";

const landingByRole = {
  contracts_Admin: "35KBoSgoAK",
  contracts_OrgAdmin: "35KBoSgoAK",
  contracts_Editor: "35KBoSgoAK",
  contracts_User: "35KBoSgoAK"
};

export const normalizeServerUrl = (serverUrl) => {
  if (!serverUrl) {
    return "";
  }
  return serverUrl.endsWith("/") ? serverUrl : `${serverUrl}/`;
};

export const bootstrapLegacyStorage = () => {
  localStorage.setItem("baseUrl", normalizeServerUrl(env.serverUrl));
  localStorage.setItem("parseAppId", env.appId);
};

export const persistSession = (user) => {
  if (!user?.sessionToken) {
    return;
  }

  localStorage.setItem("accesstoken", user.sessionToken);
  localStorage.setItem("UserInformation", JSON.stringify(user));
  localStorage.setItem("userEmail", user.email || "");
  localStorage.setItem("username", user.name || "");
};

export const persistExtendedUser = (extUser) => {
  if (!extUser) {
    return;
  }

  const extUserObject = typeof extUser?.toJSON === "function" ? extUser.toJSON() : extUser;
  localStorage.setItem("Extand_Class", JSON.stringify([extUserObject]));
  localStorage.setItem("userEmail", extUserObject?.Email || localStorage.getItem("userEmail") || "");
  localStorage.setItem("username", extUserObject?.Name || localStorage.getItem("username") || "");
  const currentUserInformation = (() => {
    try {
      const rawValue = localStorage.getItem("UserInformation");
      return rawValue ? JSON.parse(rawValue) : {};
    } catch (error) {
      return {};
    }
  })();
  localStorage.setItem(
    "UserInformation",
    JSON.stringify({
      ...currentUserInformation,
      language: extUserObject?.Language || extUserObject?.language || currentUserInformation?.language || "",
      Language: extUserObject?.Language || extUserObject?.language || currentUserInformation?.Language || ""
    })
  );

  const tenantId = extUserObject?.TenantId?.objectId;
  const tenantName = extUserObject?.TenantId?.TenantName;
  if (tenantId) {
    localStorage.setItem("TenantId", tenantId);
  }
  if (tenantName) {
    localStorage.setItem("TenantName", tenantName);
  }
};

export const getLandingForRole = (role) => landingByRole[role] || "35KBoSgoAK";

export const getSessionToken = () => localStorage.getItem("accesstoken") || "";

export const clearSession = () => {
  const baseUrl = localStorage.getItem("baseUrl");
  const parseAppId = localStorage.getItem("parseAppId");
  const language = localStorage.getItem("i18nextLng");
  localStorage.clear();
  if (baseUrl) {
    localStorage.setItem("baseUrl", baseUrl);
  }
  if (parseAppId) {
    localStorage.setItem("parseAppId", parseAppId);
  }
  if (language) {
    localStorage.setItem("i18nextLng", language);
  }
};
